import React, { useState, useEffect,useRef } from "react";
import client from "../../api";
import { useParams } from "react-router-dom";
import { notifyError,notifyInfo } from "../../helper";
import {exportCampaignRecipientsReport} from "../../helper";

const StepSummary = (props) => {
    const {step,index} = props;
    const api = client();
    const {campaignID} = useParams('');
    const [toggleDotMenu,setToggleDotMenu] = useState(false);
    const [exportLoader, setExportLoader] = useState(false);
    const dotMenuRef = useRef(null);

    const getPercentForSent = (total, value) => {
        return total > 0 ? ((value/total)*100) : 0;
    }
    const sentPercent = getPercentForSent(step?.total_recipients, step?.email_event_counts?.sent);
    const pendingPercent = getPercentForSent(step?.total_recipients, step?.pending_recipients);
    
    const handleCampaignStepRecipientsDownload = async(stepId) => {
        try{
            setExportLoader(true);
            const payload = {
                campaign_id:campaignID,
                step_id: stepId
            };
            
            const response = await api.post("/v1/campaign/stage/export",payload);
            if(response.status === 200 || response.status === 201){
                if(Object.keys(response.data.eventsCountPerContact).length){
                    exportCampaignRecipientsReport(response.data.eventsCountPerContact,"campaings_steps_recipients");
                } else {
                    notifyInfo('Data is not available');
                }
            }
        } catch(error){
            setExportLoader(false);
            console.log('error.message',error);
            if(error.status === 400){ notifyError("Bad Request. Unable to fetch Step Recipients. Please try again.") }
        } finally {
            setExportLoader(false);
        }
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dotMenuRef.current && !dotMenuRef.current.contains(event.target)) {
                setToggleDotMenu(false);
            } 
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return(
        <div className="summary-blocks-inner">
            <div className="record-count-wrap">
                
                <div className={`record-count ${ index ? 'bi-directional':''}`}>
                    {step?.total_recipients}<span>Recipients</span>
                </div>
            </div>
            <div className={`record-details ${step.status}`}>
                <div className="box-head">
                    <div className="left-side">
                        <div className="dot-menu-box" ref={dotMenuRef}>
                            <button className="dot-menu-btn" onClick={()=>setToggleDotMenu(!toggleDotMenu)}>
                                <i className="bx bx-dots-vertical-rounded"></i>
                            </button>
                            <ul className={toggleDotMenu ? `overview-menu open`:`overview-menu`}>
                                <li>
                                    <button 
                                        type="button" 
                                        className={exportLoader ? "export-btn button--loading":"export-btn"} 
                                        disabled={exportLoader}
                                        onClick={()=>handleCampaignStepRecipientsDownload(step.step_id)}>
                                            <span className="button--text">Export</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    <h4 className={`${ index ? 'mb-0':''}`}>{step.subject}</h4>
                </div>
                <div className={`box-status ${step.status}`}>
                {step.status === 'pause' ? <>
                    <i className='bx bxs-error' ></i> This Message is Paused
                </>:''}
                {step.status === "active" ? <>
                    <i className='bx bxs-check-circle' ></i> Active
                </>:''}
                </div>
                
                </div>
                {index ? <h5>{step.minimum_delay_after_last_send} Days Later</h5>:''}
                <ul className="colored-record">
                    <li className={(props.messageType === 'text/plain' || !props.trackOpen) ? 'row-1 opacity-30':'row-1'}>
                        <div className="row-data">{step?.email_event_counts_percentage?.open?.count}</div>
                        <div className="data-percent">{step?.email_event_counts_percentage?.open?.percentage}%</div>
                        <div className="data-label">Opened</div>
                    </li>
                    <li className={(props.messageType === 'text/plain' || !props.trackClicks) ? 'row-2 opacity-30':'row-2'}>
                        <div className="row-data">{step?.email_event_counts_percentage?.click?.count}</div>
                        <div className="data-percent">{step?.email_event_counts_percentage?.click?.percentage}%</div>
                        <div className="data-label">Clicked</div>
                    </li>
                    <li className="row-3">
                        <div className="row-data">{step?.email_event_counts_percentage?.reply?.count}</div>
                        <div className="data-percent">{step?.email_event_counts_percentage?.reply?.percentage}%</div>
                        <div className="data-label">Replied</div>
                    </li>
                    <li className="row-4">
                        <div className="row-data">{step?.email_event_counts_percentage?.bounce?.count}</div>
                        <div className="data-percent">{step?.email_event_counts_percentage?.bounce?.percentage}%</div>
                        <div className="data-label">Bounced</div>
                    </li>
                    <li className="row-5">
                        <div className="row-data">{step?.email_event_counts_percentage?.unsubscribe?.count}</div>
                        <div className="data-percent">{step?.email_event_counts_percentage?.unsubscribe?.percentage}%</div>
                        <div className="data-label">Unsubscribed</div>
                    </li>
                </ul>
                <div className="record-status">
                    
                    {sentPercent > 0 ? <span className="sent-bar" style={{width:`${sentPercent}%`}}><i className={sentPercent < 6 ? 'shift':''}>{step?.email_event_counts?.sent} <br/> sent</i></span>:''}
                    {pendingPercent > 0 ? <span className="pending-bar" style={{width:`${pendingPercent}%`}}><i className={pendingPercent < 6 ? 'shift':''}>{step?.pending_recipients} <br/> pending</i></span>:''}
                </div>
            </div>
        </div>
    );
}

export default StepSummary;